var m = require('mithril');
var R = require('ramda');
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var columnModalView = require('./columnModalView');
var columnValidation = require('./datasetColumnModalValidation');

const maxId = R.compose(R.propOr(0, 'id'), R.head, R.sort(R.descend(R.prop('id'))));


function addColumn(datasetRecord, options) {  
  var modalState = {
    errors: []
  };
  var newId;
  if (!datasetRecord.columns) {
    datasetRecord.columns = [];
  }
  if (Array.isArray(datasetRecord.columns) && datasetRecord.columns.length == 0) {
    newId = 0;
  } else {
    newId = maxId(datasetRecord.columns) + 1;
  }

  let newColumn = {
    name: '',
    id: newId
  }

  modal.vm.title('New Column');
  modal.vm.body = columnModalView.bind(null, newColumn, modalState);

  var submit = function() {
    modalState.errors = columnValidation.validateColumnName(newColumn, datasetRecord.columns);
    if (modalState.errors.length) {
      m.redraw();
      return Promise.resolve(false);
    }
    columnValidation.applyNormalizedColumnName(newColumn);
    datasetRecord.columns.push(newColumn)
    return loaders.requestWithLoader({
      loader: 'background',
      url: `api/v1/dataset/${datasetRecord['@rid'].slice(1)}`,
      method: 'PUT',
      body: {columns: datasetRecord.columns}
    })
    .then(function () {
      key.unbind('enter');
      modal.vm.close();
      options && options.dashboardCallback ? options.dashboardCallback() : '';
      options && options.submitCallback ? options.submitCallback() : ''
    })
  }

  modal.vm.buttons([
    {
      label: "Submit",
      class: "dib ",
      func: submit
    }
  ])

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.open();
};


function addColumnOnDataset(ctrl) {
  return m('i.icon.ion-plus.blue', {
    onclick: addColumn.bind(null, ctrl.dataset, ctrl)
  })


}


module.exports = addColumnOnDataset;
